import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cinematic%20illustration%2C%20epic%20manga%20panorama%20with%20multiple%20comic%20characters%20in%20dynamic%20poses%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20stylized%20artistic%20composition%2C%20dramatic%20lighting%20from%20center%2C%20digital%20painting%20style%2C%20rich%20textures%2C%20no%20text%2C%20atmospheric%20with%20soft%20glow%20effects%2C%20clean%20empty%20area%20at%20center%20for%20text%20overlay&width=1920&height=1080&seq=hero-manga-home&orientation=landscape"
          alt="虫虫漫画网 - 下拉式韩国漫画免费阅读"
          title="虫虫漫画网 - 无删减漫画免费阅读平台"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 mb-6">
          <i className="ri-sparkling-2-line text-accent-400 text-xs"></i>
          <span className="text-accent-200 text-xs md:text-sm font-medium">韩国漫画 · 下拉式完整版免费阅读</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-4">
          下拉式完整版
          <br />
          无删减漫画<span className="text-accent-400">免费阅读</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-8 leading-relaxed">
          虫虫漫画网主打下拉式完整版免费阅读，无删减韩国漫画资源充足，
          <br className="hidden md:block" />
          下拉观看流畅不卡顿，免费为您呈现各类精彩韩国漫画的完整版剧情与画面。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/korea"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-medium rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 text-sm md:text-base font-medium rounded-lg border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </Link>
        </div>

        {/* Stats */}
        <div className="mt-12 grid grid-cols-3 gap-8 max-w-lg mx-auto">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">2000+</div>
            <div className="text-xs text-background-50/60 mt-1">漫画资源</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">500万+</div>
            <div className="text-xs text-background-50/60 mt-1">忠实读者</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">300+</div>
            <div className="text-xs text-background-50/60 mt-1">月更新量</div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/50"></i>
      </div>
    </section>
  );
}